import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Composites Lumber Contact Us`('0.0.1')({
  gutterless: true,
  view: () => <UI.Modules.Page.Reusable value={ {path: 'composites', name: 'Composites Lumber Contact Us' } } />,
  edit: {}
});
